import { render, staticRenderFns } from "./FakeImages.vue?vue&type=template&id=6f0955f8&scoped=true&"
import script from "./FakeImages.vue?vue&type=script&lang=js&"
export * from "./FakeImages.vue?vue&type=script&lang=js&"
import style0 from "./FakeImages.vue?vue&type=style&index=0&id=6f0955f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0955f8",
  null
  
)

export default component.exports